export const killabearsNFTs = [
  
  {
    id: 'killabears-3287',
    name: 'KILLABEARS #3287',
    image: 'https://assets.killabears.com/content/killabears/img/3287-d89312fe2889debe8b14f83843d3868824f90106ab694b8249df7ed4da9a5db1.png',
    price: '0.85 ETH'
  },
  {
    id: 'killabears-3227',
    name: 'KILLABEARS #3227',
    image: 'https://assets.killabears.com/content/killabears/img/3227-bdfa4bc0c372079c0cb36331865e9a9a78cf0501441a0db1a8f259806cb8d05b.png',
    price: '0.45 ETH'
  },
  {
    id: 'killabears-3207',
    name: 'KILLABEARS #3207',
    image: 'https://assets.killabears.com/content/killabears/img/3207-486e160ad5df51fc876e64a56f9f8f6652beefaf4b0667eca2b7dcaaa385a33c.png',
    price: '1.15 ETH'
  },
  {
    id: 'killabears-3252',
    name: 'KILLABEARS #3252',
    image: 'https://assets.killabears.com/content/killabears/img/3252-82628f29af3e7e1d52452b7d795d8d1032c06d8757662e17f91836c28e3aeed5.png',
    price: '0.65 ETH'
  },
  {
    id: 'killabears-3276',
    name: 'KILLABEARS #3276',
    image: 'https://assets.killabears.com/content/killabears/img/3276-f3b4dfbb21335328421268259b96132d1a070891cf067b049ec5b26b0ba65106.png',
    price: '0.95 ETH'
  },
  {
    id: 'killabears-3320',
    name: 'KILLABEARS #3320',
    image: 'https://assets.killabears.com/content/killabears/img/3320-fe54a6f06bd394345b17c5a2c39bcfde9242b835a1ae7f6e2ebe2566cb8154b1.png',
    price: '0.35 ETH'
  },
  {
    id: 'killabears-3286',
    name: 'KILLABEARS #3286',
    image: 'https://assets.killabears.com/content/killabears/img/3286-429c28123c08b8a858d7c86965281e707d3030f760e6f8ecc79b9201157052c2.png',
    price: '1.05 ETH'
  },
  {
    id: 'killabears-3226',
    name: 'KILLABEARS #3226',
    image: 'https://assets.killabears.com/content/killabears/img/3226-f6bcf7b833bae93f1d2215bde68a8852b2fc4ffe58a965eb2a904189de550a75.png',
    price: '0.55 ETH'
  },
  {
    id: 'killabears-3206',
    name: 'KILLABEARS #3206',
    image: 'https://assets.killabears.com/content/killabears/img/3206-8331dab3733be2ef03e535f9699e78f98740703a550248b5f744aa6fe8d891dc.png',
    price: '0.75 ETH'
  },
  {
    id: 'killabears-3251',
    name: 'KILLABEARS #3251',
    image: 'https://assets.killabears.com/content/killabears/img/3251-e265105b1b90b5d7d34e0546240e4b53ea16b4086f3fd303602bd92d7b3ad4f0.png',
    price: '1.18 ETH'
  },
  {
    id: 'killabears-3275',
    name: 'KILLABEARS #3275',
    image: 'https://assets.killabears.com/content/killabears/img/3275-d5d2c75683d87e320e45ec0c14e7a6228f7a0028b5d67c62a20a81c54a8099ac.png',
    price: '0.28 ETH'
  },
  {
    id: 'killabears-3319',
    name: 'KILLABEARS #3319',
    image: 'https://assets.killabears.com/content/killabears/img/3319-065bd6b18bd00d5b83d518207fc7b708f59a485aa1a873ffd20040c87fa3c548.png',
    price: '0.92 ETH'
  },
  {
    id: 'killabears-3285',
    name: 'KILLABEARS #3285',
    image: 'https://assets.killabears.com/content/killabears/img/3285-e0da4a52886343010eda8bfe1ed4b23125b1884750989e0370f194d0d365c5f7.png',
    price: '0.48 ETH'
  },
  {
    id: 'killabears-3311',
    name: 'KILLABEARS #3311',
    image: 'https://assets.killabears.com/content/killabears/img/3311-7e2670552c77e747b7490df5dcb0b660269eea11f887f870a24717a366b36843.png',
    price: '1.12 ETH'
  },
  {
    id: 'killabears-3225',
    name: 'KILLABEARS #3225',
    image: 'https://assets.killabears.com/content/killabears/img/3225-ce34d346d3940642afa9141249e8d32f62a8f53815893210e00c5d527b8b8048.png',
    price: '0.62 ETH'
  },
  {
    id: 'killabears-3205',
    name: 'KILLABEARS #3205',
    image: 'https://assets.killabears.com/content/killabears/img/3205-772b71d3c2d33db1e0169246caca866d0f5e204705052a497c8483f421c665c0.png',
    price: '0.88 ETH'
  },
  {
    id: 'killabears-3250',
    name: 'KILLABEARS #3250',
    image: 'https://assets.killabears.com/content/killabears/img/3250-5aad6166700a709056e8b0304a548ef6d6f10532089a776a4c2e3eddc66e394e.png',
    price: '0.42 ETH'
  },
  {
    id: 'killabears-3318',
    name: 'KILLABEARS #3318',
    image: 'https://assets.killabears.com/content/killabears/img/3318-7b86a3aef0e4e372b5cef024cc144514dd14bc5011bb6e01c6389d2788854e5d.png',
    price: '1.08 ETH'
  },
  {
    id: 'killabears-3284',
    name: 'KILLABEARS #3284',
    image: 'https://assets.killabears.com/content/killabears/img/3284-4f132c5798c4f65741316b513bfec34d64762289b5f3ac333cfdc8af6648a94b.png',
    price: '0.52 ETH'
  },
  {
    id: 'killabears-3274',
    name: 'KILLABEARS #3274',
    image: 'https://assets.killabears.com/content/killabears/img/3274-3e8b61627341ad4e60b4f11031f3efd27528ad20cf575d5ff26faf6505083bf2.png',
    price: '0.95 ETH'
  },
  {
    id: 'killabears-3310',
    name: 'KILLABEARS #3310',
    image: 'https://assets.killabears.com/content/killabears/img/3310-62430e610198cdc43a974efed5f1f1a1e9c6d7d579c47b6ad2075cb71b7f24ae.png',
    price: '0.32 ETH'
  },
  {
    id: 'killabears-3204',
    name: 'KILLABEARS #3204',
    image: 'https://assets.killabears.com/content/killabears/img/3204-b64f1d078212d2af3776493c1f0d9898f2ff030f896760d83f360e694989ec5a.png',
    price: '0.78 ETH'
  },
  {
    id: 'killabears-3224',
    name: 'KILLABEARS #3224',
    image: 'https://assets.killabears.com/content/killabears/img/3224-5488070e155d7fd4408f31faa108646930fe32305e55818f821d7efc12e345f3.png',
    price: '0.45 ETH'
  },
  {
    id: 'killabears-3249',
    name: 'KILLABEARS #3249',
    image: 'https://assets.killabears.com/content/killabears/img/3249-f8da33b69bbdb6ce7870fb6b83f9ed341c04eab5e91fa2e30ee244879132590b.png',
    price: '1.15 ETH'
  },
  {
    id: 'killabears-3283',
    name: 'KILLABEARS #3283',
    image: 'https://assets.killabears.com/content/killabears/img/3283-299dc21b07e189398f5afd79af0e9261a66ab66978d88fa680d610a23de784c4.png',
    price: '0.65 ETH'
  },
  {
    id: 'killabears-3309',
    name: 'KILLABEARS #3309',
    image: 'https://assets.killabears.com/content/killabears/img/3309-8663689f6b251b35c7129b2eb15f95c80d80094ba5dd7ee47fbdf50045a25aa2.png',
    price: '0.95 ETH'
  },
  {
    id: 'killabears-3203',
    name: 'KILLABEARS #3203',
    image: 'https://assets.killabears.com/content/killabears/img/3203-e2080aa5bbd89bdf8aaefce2dbde25a4fa5b3f12ab9c47fa92eec7f1feb63739.png',
    price: '0.35 ETH'
  },
  {
    id: 'killabears-3273',
    name: 'KILLABEARS #3273',
    image: 'https://assets.killabears.com/content/killabears/img/3273-3d79219f5b34d6f0cb66e130b1aa0a6430cfdc62b43440edfde2baf6d02a573a.png',
    price: '1.05 ETH'
  },
  {
    id: 'killabears-3317',
    name: 'KILLABEARS #3317',
    image: 'https://assets.killabears.com/content/killabears/img/3317-6de8cedd9a50d713893fd36aed05fcfa8f8fb915b845243c5ea2b59bfc1309b9.png',
    price: '0.55 ETH'
  },
  {
    id: 'killabears-3223',
    name: 'KILLABEARS #3223',
    image: 'https://assets.killabears.com/content/killabears/img/3223-59d21b0df01217be7c45010a0f4f9e4bb1f385d7c0d45437b83f8c1ceebee04a.png',
    price: '0.75 ETH'
  },
  {
    id: 'killabears-3303',
    name: 'KILLABEARS #3303',
    image: 'https://assets.killabears.com/content/killabears/img/3303-74b0b21ffd4fd2ea1aa6a0eff7bcae8afa1e76a50e3538992f946d0b1e3f2dbf.png',
    price: '1.18 ETH'
  },
  {
    id: 'killabears-3248',
    name: 'KILLABEARS #3248',
    image: 'https://assets.killabears.com/content/killabears/img/3248-1913a487361aa04e032c45cfc2eef216ff0df59c2b4a3f1683a32f205c205640.png',
    price: '0.28 ETH'
  },
  {
    id: 'killabears-3182',
    name: 'KILLABEARS #3182',
    image: 'https://assets.killabears.com/content/killabears/img/3182-57b6865ea2df3f901bb526d01a46579f72895066969905cd50cffae08abc95db.png',
    price: '0.92 ETH'
  },
  {
    id: 'killabears-3282',
    name: 'KILLABEARS #3282',
    image: 'https://assets.killabears.com/content/killabears/img/3282-333029e58868b1cfe845f5f4ec5302109b4a344f055c1e6936025bb023ac4688.png',
    price: '0.48 ETH'
  },
  {
    id: 'killabears-3308',
    name: 'KILLABEARS #3308',
    image: 'https://assets.killabears.com/content/killabears/img/3308-8e59f4a201b004406be81aa60eb9ff8b65ef73c840c5298d0a0e04873c61ca5d.png',
    price: '1.12 ETH'
  },
  {
    id: 'killabears-3267',
    name: 'KILLABEARS #3267',
    image: 'https://assets.killabears.com/content/killabears/img/3267-8534c4cc24ffeb27ab808a97d51ad77fdb19901d920d5148c4b8923092346422.png',
    price: '0.62 ETH'
  },
  {
    id: 'killabears-3316',
    name: 'KILLABEARS #3316',
    image: 'https://assets.killabears.com/content/killabears/img/3316-1dcab246f5c21224455aeaf138b48323d0aa0e49d7b3bf8975abca5cf2181a74.png',
    price: '0.88 ETH'
  },
  {
    id: 'killabears-3272',
    name: 'KILLABEARS #3272',
    image: 'https://assets.killabears.com/content/killabears/img/3272-b0455ba25e876aa6bb3d3dc214935bf1ccf1323a9c042c843c200c602b6b3a87.png',
    price: '0.42 ETH'
  },
  {
    id: 'killabears-3222',
    name: 'KILLABEARS #3222',
    image: 'https://assets.killabears.com/content/killabears/img/3222-5077948817f650d78c483b344e2e1411bbca57995d8b195b793aa568d5b9c52d.png',
    price: '1.08 ETH'
  },
  {
    id: 'killabears-3242',
    name: 'KILLABEARS #3242',
    image: 'https://assets.killabears.com/content/killabears/img/3242-19db5c43413ac576d99779507330dffa3be1a951f07e02bef21ed139c289eb39.png',
    price: '0.52 ETH'
  },
  {
    id: 'killabears-3202',
    name: 'KILLABEARS #3202',
    image: 'https://assets.killabears.com/content/killabears/img/3202-c4764d1d07ef0f91f878489584552cd17994d844032c0dd753a80a7dac9d1bdb.png',
    price: '0.95 ETH'
  },
  {
    id: 'killabears-3247',
    name: 'KILLABEARS #3247',
    image: 'https://assets.killabears.com/content/killabears/img/3247-c8da06d6254f53cf6945167fa414fd7b79044c70c466ccdcc99cd336dfa1d84a.png',
    price: '0.32 ETH'
  },
  {
    id: 'killabears-3187',
    name: 'KILLABEARS #3187',
    image: 'https://assets.killabears.com/content/killabears/img/3187-d2c2226b818dcb3906618e72fd1ff41281e53d4bb47904c1daf8e73703f5dc8d.png',
    price: '0.78 ETH'
  },
  {
    id: 'killabears-3192',
    name: 'KILLABEARS #3192',
    image: 'https://assets.killabears.com/content/killabears/img/3192-84b3f8de619881d876e42f5b50e23e01b6e04f1ba660afc2d20c9e4e9871def2.png',
    price: '1.15 ETH'
  },
  {
    id: 'killabears-3181',
    name: 'KILLABEARS #3181',
    image: 'https://assets.killabears.com/content/killabears/img/3181-783cad82842720b35884e018538bc2783c960fb950f623445b8716924008fa97.png',
    price: '0.65 ETH'
  },
  {
    id: 'killabears-3197',
    name: 'KILLABEARS #3197',
    image: 'https://assets.killabears.com/content/killabears/img/3197-8546fae4891baaba32704af0109a95c47dc925f2ad87ee4a9ed2001f8ae7dcb7.png',
    price: '0.95 ETH'
  },
  {
    id: 'killabears-3302',
    name: 'KILLABEARS #3302',
    image: 'https://assets.killabears.com/content/killabears/img/3302-c0c02ad5c91815391a663229a78167070ea5528cc0b0ec6151e0fb99fdc5aea9.png',
    price: '0.35 ETH'
  },
  {
    id: 'killabears-3307',
    name: 'KILLABEARS #3307',
    image: 'https://assets.killabears.com/content/killabears/img/3307-b35908ffdfddab72f8a457d0cc6cf39d20c92b02f891f571b881458f63ebe0b0.png',
    price: '1.05 ETH'
  },
    {
      id: 'killabears-3237',
      name: 'KILLABEARS #3237',
      image: 'https://assets.killabears.com/content/killabears/img/3237-71448b9dfa6b84d1db197945f1ad9cbdab693a55347371803e21531d63f3d9bc.png',
      price: '0.85 ETH'
    },
    {
      id: 'killabears-3331', 
      name: 'KILLABEARS #3331',
      image: 'https://assets.killabears.com/content/killabears/img/3331-6e3ee546282ceaa35c10b79aa21ead395a8eb39e8a5b1c6b9cb25cbcf4078bef.png',
      price: '0.45 ETH'
    },
    {
      id: 'killabears-3217',
      name: 'KILLABEARS #3217', 
      image: 'https://assets.killabears.com/content/killabears/img/3217-2feb034241e1b9dc12d7e9a44bc55caf57a0eb335bf9b3eb0be8607e385d2ff0.png',
      price: '1.15 ETH'
    },
    {
      id: 'killabears-3236',
      name: 'KILLABEARS #3236',
      image: 'https://assets.killabears.com/content/killabears/img/3236-d679e40333e66b8cea3187021efffd19bc86deb4132d6355d104c9dca4115b3f.png',
      price: '0.65 ETH'
    },
    {
      id: 'killabears-3297',
      name: 'KILLABEARS #3297',
      image: 'https://assets.killabears.com/content/killabears/img/3297-e35129977b4d3bd524530fcd31fd732c85f00f04539a47eaea53094d14c4960d.png',
      price: '0.95 ETH'
    },
    {
      id: 'killabears-3330',
      name: 'KILLABEARS #3330',
      image: 'https://assets.killabears.com/content/killabears/img/3330-e47208ee8381b6c089be7af294803330783ca890d951bd8f1fa69c1ca3852be6.png',
      price: '0.35 ETH'
    },
    {
      id: 'killabears-3262',
      name: 'KILLABEARS #3262',
      image: 'https://assets.killabears.com/content/killabears/img/3262-fa853bc2aea9e107b2438f70167762e8e16745bba883763573afe0cae0c51d1b.png',
      price: '1.05 ETH'
    },
    {
      id: 'killabears-3216',
      name: 'KILLABEARS #3216',
      image: 'https://assets.killabears.com/content/killabears/img/3216-a78452db29078f26d4cd75114fc99db39e3b83ce7939dbb6245308585d652288.png',
      price: '0.55 ETH'
    },
    {
      id: 'killabears-3296',
      name: 'KILLABEARS #3296',
      image: 'https://assets.killabears.com/content/killabears/img/3296-6c7d5ec3ca9b25c7a2f4a79835171161fc0ae904a08269bf36c99cd1d8b33a9f.png',
      price: '0.75 ETH'
    },
    {
      id: 'killabears-3235',
      name: 'KILLABEARS #3235',
      image: 'https://assets.killabears.com/content/killabears/img/3235-bfb4b8ba045254f37b1a4e35bccd5dff8fb8058a2f4af9d5a5914f9148d57bcb.png',
      price: '1.18 ETH'
    },
    {
      id: 'killabears-3329',
      name: 'KILLABEARS #3329',
      image: 'https://assets.killabears.com/content/killabears/img/3329-fe04875db3a44d388dc95331d8e88f7736646796d09b27c68102bda317b97b55.png',
      price: '0.28 ETH'
    },
    {
      id: 'killabears-3261',
      name: 'KILLABEARS #3261',
      image: 'https://assets.killabears.com/content/killabears/img/3261-62e65ca37e03fc1565e78c5cb0a69ad6b46d6bebd9136f7ccd4977773e618b05.png',
      price: '0.92 ETH'
    },
    {
      id: 'killabears-3215',
      name: 'KILLABEARS #3215',
      image: 'https://assets.killabears.com/content/killabears/img/3215-7a3e8673f377606fe53ee4c790ca1e52bcd4f1dba4808f58e77b33488205ae59.png',
      price: '0.48 ETH'
    },
    {
      id: 'killabears-3295',
      name: 'KILLABEARS #3295',
      image: 'https://assets.killabears.com/content/killabears/img/3295-9fa90f42ae8001fc75024358c5c655649a18425b3bb64d10fc8846b08fc7aaf8.png',
      price: '1.12 ETH'
    },
    {
      id: 'killabears-3328',
      name: 'KILLABEARS #3328',
      image: 'https://assets.killabears.com/content/killabears/img/3328-66a8998ce321f664843bc3362800cd76c18b537b2e2d3732441e1323aee34180.png',
      price: '0.62 ETH'
    },
    {
      id: 'killabears-3234',
      name: 'KILLABEARS #3234',
      image: 'https://assets.killabears.com/content/killabears/img/3234-8da0d8ccc77f804a887a626f5fd49e9ec48821a3470a87f05ce7088d8c6774bd.png',
      price: '0.88 ETH'
    },
    {
      id: 'killabears-3260',
      name: 'KILLABEARS #3260',
      image: 'https://assets.killabears.com/content/killabears/img/3260-a9587a2bcb8e0c81b5ef12cfd37fc5509f150c4e7c57fc80cecfb5ac903325bb.png',
      price: '0.42 ETH'
    },
    {
      id: 'killabears-3214',
      name: 'KILLABEARS #3214',
      image: 'https://assets.killabears.com/content/killabears/img/3214-01965ac7bbc9ab0aa1ff258333fde1978b0a31f3c687f990079d2144e65b0121.png',
      price: '1.08 ETH'
    },
    {
      id: 'killabears-3294',
      name: 'KILLABEARS #3294',
      image: 'https://assets.killabears.com/content/killabears/img/3294-3c8764de1f12a74b750a87733484a1b28fe92c8de2777e5b4ad48960ed7ffe66.png',
      price: '0.52 ETH'
    },
    {
      id: 'killabears-3233',
      name: 'KILLABEARS #3233',
      image: 'https://assets.killabears.com/content/killabears/img/3233-2704e1db616f56bb5d59a58957f75be0e0075f6cb78f813c877e2938b04812b4.png',
      price: '0.95 ETH'
    },
    {
      id: 'killabears-3259',
      name: 'KILLABEARS #3259',
      image: 'https://assets.killabears.com/content/killabears/img/3259-2f4bf6c9a1c9d51834a23234ee6816f63c4539597b6dab5c7483bc48a988e606.png',
      price: '0.32 ETH'
    },
    {
      id: 'killabears-3327',
      name: 'KILLABEARS #3327',
      image: 'https://assets.killabears.com/content/killabears/img/3327-5b6a8b8d9c9d436e7cad759f248afa1d1377b254de4f5f3a3fb59fa46ca1bda5.png',
      price: '0.78 ETH'
    },
    {
      id: 'killabears-3213',
      name: 'KILLABEARS #3213',
      image: 'https://assets.killabears.com/content/killabears/img/3213-d0f55716e0193577b6e10ea291d56bbf0812b0ca11128233d565da778ba272d5.png',
      price: '1.15 ETH'
    },
    {
      id: 'killabears-3293',
      name: 'KILLABEARS #3293',
      image: 'https://assets.killabears.com/content/killabears/img/3293-52394be22d42c618bb3dba3013b457373024319dd50a7f40d1b7edae60d2ea9b.png',
      price: '0.65 ETH'
    },
    {
      id: 'killabears-3258',
      name: 'KILLABEARS #3258',
      image: 'https://assets.killabears.com/content/killabears/img/3258-eed4794b5d099cfbc59f7f9681d9b4a04afcfa66ee52079f7e4099b45897afcb.png',
      price: '0.95 ETH'
    },
    {
      id: 'killabears-3326',
      name: 'KILLABEARS #3326',
      image: 'https://assets.killabears.com/content/killabears/img/3326-fde11301e91b810f330b9658e7474d8df2c0df038e9659bbf04f12ae99fa8cf7.png',
      price: '0.35 ETH'
    },
    {
      id: 'killabears-3232',
      name: 'KILLABEARS #3232',
      image: 'https://assets.killabears.com/content/killabears/img/3232-d92e2249d33d2380422450e53f7ae708ac5f6fc181018f22a5622f34f9f22609.png',
      price: '1.05 ETH'
    },
    {
      id: 'killabears-3212',
      name: 'KILLABEARS #3212',
      image: 'https://assets.killabears.com/content/killabears/img/3212-035981f244a78bddc549001f5a42ae939081210c09b311009b007e5239e1d54f.png',
      price: '0.55 ETH'
    },
    {
      id: 'killabears-3292',
      name: 'KILLABEARS #3292',
      image: 'https://assets.killabears.com/content/killabears/img/3292-677843126a62d31b4c4afb51d6d53b1e4a7ac4464aba84cf706643ba211a36a6.png',
      price: '0.75 ETH'
    },
    {
      id: 'killabears-3257',
      name: 'KILLABEARS #3257',
      image: 'https://assets.killabears.com/content/killabears/img/3257-442b0a79e96462ea8a4a3b194fc6adc3dd45e424ebd21c7bdbf133d17c46be11.png',
      price: '1.18 ETH'
    },
    {
      id: 'killabears-3325',
      name: 'KILLABEARS #3325',
      image: 'https://assets.killabears.com/content/killabears/img/3325-29e9503e8a01737e4d6c7c0cbfe5c058240bfa1b4a8bdf1edd41b310b4d92cb4.png',
      price: '0.28 ETH'
    },
    {
      id: 'killabears-3231',
      name: 'KILLABEARS #3231',
      image: 'https://assets.killabears.com/content/killabears/img/3231-f05e667c40dc99978d37694d169771abb1290138219d39710bb40c87478a78c3.png',
      price: '0.92 ETH'
    },
    {
      id: 'killabears-3211',
      name: 'KILLABEARS #3211',
      image: 'https://assets.killabears.com/content/killabears/img/3211-4830e04b66e635da864f4440ca01772bc799d06f383f2102f88ad0835965fbc5.png',
      price: '0.48 ETH'
    },
    {
      id: 'killabears-3291',
      name: 'KILLABEARS #3291',
      image: 'https://assets.killabears.com/content/killabears/img/3291-e468b3c31d26e1f9f39ed74a9a761d40ce6f4d59a892fb12975131902a8df6ff.png',
      price: '1.12 ETH'
    },
    {
      id: 'killabears-3256',
      name: 'KILLABEARS #3256',
      image: 'https://assets.killabears.com/content/killabears/img/3256-217bf41a0845276e8e374ee73813b4237d8a9de349f5873cb015423073d96899.png',
      price: '0.62 ETH'
    },
    {
      id: 'killabears-3324',
      name: 'KILLABEARS #3324',
      image: 'https://assets.killabears.com/content/killabears/img/3324-4dacb0546976e4051a2896539208b17c9cb048fdfe0a645cf3eb962489d166e5.png',
      price: '0.88 ETH'
    },
    {
      id: 'killabears-3290',
      name: 'KILLABEARS #3290',
      image: 'https://assets.killabears.com/content/killabears/img/3290-81644938aad10472928a04710eae6d9a3647b67a875985d405bbaddc8b4d8b6b.png',
      price: '0.42 ETH'
    },
    {
      id: 'killabears-3230',
      name: 'KILLABEARS #3230',
      image: 'https://assets.killabears.com/content/killabears/img/3230-f236cd1a5254a8f767b652a4d097c00d750d58e0ea05e7f1c74d83a7ac385c6d.png',
      price: '1.08 ETH'
    },
    {
      id: 'killabears-3210',
      name: 'KILLABEARS #3210',
      image: 'https://assets.killabears.com/content/killabears/img/3210-8b4bd5fc1dd635e8d272a1f83163e64794aa4b82863d8d451672722910a22f8c.png',
      price: '0.52 ETH'
    },
    {
      id: 'killabears-3255',
      name: 'KILLABEARS #3255',
      image: 'https://assets.killabears.com/content/killabears/img/3255-f3f1a5d982a6d08e4bd1392e5a903377a339bd18d6ae7e5051b1061a703a9b2a.png',
      price: '0.95 ETH'
    },
    {
      id: 'killabears-3323',
      name: 'KILLABEARS #3323',
      image: 'https://assets.killabears.com/content/killabears/img/3323-bcb53fe5601b993bf95494ff9f3449988dc3ef28df2e30a226937c8804f9764d.png',
      price: '0.32 ETH'
    },
    {
      id: 'killabears-3289',
      name: 'KILLABEARS #3289',
      image: 'https://assets.killabears.com/content/killabears/img/3289-31091b1984549d28850305016cef5e6bd1c345d05b1c2536e23ac80ee76288e5.png',
      price: '0.78 ETH'
    },
    {
      id: 'killabears-3229',
      name: 'KILLABEARS #3229',
      image: 'https://assets.killabears.com/content/killabears/img/3229-454aa67a3cc6fffe19ae765d941db249726b5e9e21ac768d7028a8fa797232ba.png',
      price: '1.15 ETH'
    },
    {
      id: 'killabears-3209',
      name: 'KILLABEARS #3209',
      image: 'https://assets.killabears.com/content/killabears/img/3209-1e820c168ac11172e6e3fc97f7bca5fe70e669425a9084d902f6b361c9f53c9d.png',
      price: '0.65 ETH'
    },
    {
      id: 'killabears-3254',
      name: 'KILLABEARS #3254',
      image: 'https://assets.killabears.com/content/killabears/img/3254-6d3cfa010f4a5870812054421efc097b78010beaf99b1b04c23dc0206bb1dd4a.png',
      price: '0.95 ETH'
    },
    {
      id: 'killabears-3322',
      name: 'KILLABEARS #3322',
      image: 'https://assets.killabears.com/content/killabears/img/3322-0853bbd2f382d0ced766dc96c3ef42f3bee97e158ecf82b68d8d03350f184c20.png',
      price: '0.35 ETH'
    },
    {
      id: 'killabears-3288',
      name: 'KILLABEARS #3288',
      image: 'https://assets.killabears.com/content/killabears/img/3288-fdcc1becaae9a9b0bedea9966f3e9520189b8089c1e6be759d6e05e0a593bfc1.png',
      price: '1.05 ETH'
    },
    {
      id: 'killabears-3228',
      name: 'KILLABEARS #3228',
      image: 'https://assets.killabears.com/content/killabears/img/3228-53a7e01d1ec18038611240a3f0263702c456f09708dac22f64c5f4c627d69da0.png',
      price: '0.55 ETH'
    },
    {
      id: 'killabears-3208',
      name: 'KILLABEARS #3208',
      image: 'https://assets.killabears.com/content/killabears/img/3208-11635d4d35f6d917f7ff1550df56f3f564daae8e2955c5bdd7ad9be572434865.png',
      price: '0.75 ETH'
    },
    {
      id: 'killabears-3253',
      name: 'KILLABEARS #3253',
      image: 'https://assets.killabears.com/content/killabears/img/3253-0ad948da68c990e3cac1d6378c321370c03b5f7a61a399a424d9a93d16f4dc3b.png',
      price: '1.18 ETH'
    },
    {
      id: 'killabears-3277',
      name: 'KILLABEARS #3277',
      image: 'https://assets.killabears.com/content/killabears/img/3277-ed842cc3d88b24b9c1e0c6ced5a3ece18f7d0b2be2cb618d16c1cb1b930ca81b.png',
      price: '0.28 ETH'
    },
    {
      id: 'killabears-3321',
      name: 'KILLABEARS #3321',
      image: 'https://assets.killabears.com/content/killabears/img/3321-c2c4bbf21283d4f29835f8c4b8b5bb144ff8a07d0be9aeb6440c06ff9c74b353.png',
      price: '0.92 ETH'
    }
  
    
];